import { Button, Typography } from "@suraasa/placebo-ui"
import { OfferLetterType } from "api/resources/offerLetter/types"
import PDFSvg from "assets/PDFSvg.svg"
const PdfItem = ({
  attachment,
}: {
  attachment: OfferLetterType["offerLetter"]["attachments"][0]
}) => {
  return (
    <a
      href={attachment.attachment}
      download={`${attachment.title}.pdf`}
      target="_blank"
      rel="noreferrer"
      className="flex items-center rounded border border-surface-200 bg-surface-50 p-2 hover:bg-surface-100"
    >
      <img
        src={PDFSvg}
        alt="pdf-icon"
        className="mr-1.75 h-[35px] w-[27px] shadow-[0px_3px_7.5px_0px_#0000000D]"
      />
      <Typography variant="strongSmallBody" className="me-2">
        {attachment.title}
      </Typography>
      <Button variant="text" className="mb-0.5 ml-auto self-end">
        View
      </Button>
    </a>
  )
}

export default PdfItem
